import '../textbox/index.scss';
import ErrorMsg from '../errorMsg'

import { ReactComponent as ShowPassword } from '../../../../assets/icons/show-password.svg';
import { ReactComponent as ShowPasswordBlur } from '../../../../assets/icons/show-password-blur.svg';
import { ReactComponent as HidePassword } from '../../../../assets/icons/hide-password.svg';

type TextBoxProps = {
    onChange?: (arg) => void;
    onBlur?: (arg) => void;
    onFocus?: (arg) => void;
    onKeyDown?: (arg) => void;
    showPasswordHandler?: (arg) => void;
    className?: string;
    name?: string;
    value?: any;
    label?: string;
    type: string;
    id?: string;
    pattern?: string;
    isRequired?: boolean;
    disabled?: boolean
    placeholder?: string;
    defaultValue?: string
    showRegexError?: boolean
    showNullError?: boolean
    errorMessage?: string
    autoFocus?: boolean
    min?: number
    max?: number
    autocomplete?: any
    step?: number
    role?:string;
    labelClass?: string;
    showPasswordIcon?: boolean;
}

const TextBox = ({ id, name, type, min, pattern, placeholder, onChange, onBlur,onFocus, className, value, label, defaultValue, disabled,onKeyDown,labelClass }: TextBoxProps) => {
    const handleOnChange = (event) => onChange?.(event);
    const handleOnBlur = (event) => onBlur?.(event)
    const handleFocus = (event) => onFocus?.(event)
    return (
        <>
            <input
                id={id}
                name={name}
                type={type}
                pattern={pattern}
                placeholder={placeholder}
                onChange={handleOnChange}
                onBlur={handleOnBlur}
                onFocus={handleFocus}
                value={value}
                className={className}
                disabled={disabled}
                defaultValue={defaultValue}
                min={min}
                onKeyDown={onKeyDown}
                />
                
            <label htmlFor={id} className={labelClass}>{label}</label>
        </>
    );
}

//textbox with label field above
export const TextBoxWithLabelAbove = ({ id,role,  name, type, placeholder, onChange, onBlur, className, value, label, defaultValue, disabled, isRequired, showRegexError, showNullError, step, errorMessage, autoFocus, onKeyDown }: TextBoxProps) => {
    const handleOnChange = (event) => onChange?.(event);
    const handleOnBlur = (event) => onBlur?.(event)
    return (
        <div className="text-box-label-above">
            <label htmlFor={name}>
                {label}
                {
                    isRequired &&
                    <dfn title="required">
                        *
                    </dfn>
                }
            </label>
            <input
            role={role}
                id={id}
                name={name}
                type={type}
                placeholder={placeholder}
                onChange={handleOnChange}
                onKeyDown={onKeyDown}
                onBlur={handleOnBlur}
                value={value}
                className={(showRegexError || showNullError) ? `${className} danger-warn`: className }
                disabled={disabled}
                defaultValue={defaultValue} autoFocus={autoFocus}  step={step}/>
            {showRegexError && errorMessage && <ErrorMsg fieldName={name} error={errorMessage}/>}
        </div>
    );
}

//textbox with label field inside
export const TextBoxWithLabelInside = ({ id, name, type, placeholder, onChange, onBlur, className, value, label, disabled, isRequired, showRegexError, showNullError, errorMessage, autoFocus, min, max, showPasswordHandler, showPasswordIcon=false }: TextBoxProps) => {
    const handleOnChange = (event) => onChange?.(event);
    const handleOnBlur = (event) => onBlur?.(event);
    return (
        <div className="textbox__label-inside">
            <input
                id={id}
                name={name}
                type={type}
                placeholder={placeholder}
                onChange={handleOnChange}
                onBlur={handleOnBlur}
                value={value}
                className={(showRegexError || showNullError) ? `${className} danger-warn`: className }
                disabled={disabled}
                autoFocus={autoFocus}
                minLength={min}
                maxLength={max}
            />
            <label htmlFor={id}>
                {label}
                {
                    isRequired &&
                    <dfn title="required">
                        *
                    </dfn>
                }
            </label>
            {showPasswordIcon ? <div className='password-icon' onClick={() =>{ value.length && showPasswordHandler && showPasswordHandler(name)}}>{ !value.length?<ShowPasswordBlur/>:type ==='password' ? <ShowPassword/> : <HidePassword/>}</div> : null }
            {showRegexError && errorMessage && <ErrorMsg fieldName={name} error={errorMessage}/>}
        </div>
    );
};

export const TextBoxWithStep = ({ id, name, type, placeholder, onChange, onBlur, onKeyDown, className, value, label, defaultValue, disabled, isRequired, showRegexError, showNullError, errorMessage, autoFocus, min, max, autocomplete, step }: TextBoxProps) => {
    const handleOnChange = (event) => onChange?.(event);
    const handleOnBlur = (event) => onBlur?.(event);
    const handleOnKeyDown = (event) => onKeyDown?.(event);
    return (
        <>
            <label htmlFor={name}>
                {label}:
                {
                    isRequired &&
                    <dfn title="required">
                        *
                    </dfn>
                }
            </label>
            <input
                id={id}
                name={name}
                type={type}
                placeholder={placeholder}
                onChange={handleOnChange}
                onBlur={handleOnBlur}
                onKeyDown={handleOnKeyDown}
                value={value}
                className={(showRegexError || showNullError) ? `${className} danger-warn`: className }
                disabled={disabled}
                defaultValue={defaultValue} autoFocus={autoFocus} 
                autoComplete={autocomplete}
                min={min}
                max={max}
                step={step}
                />
            {showRegexError && errorMessage && <ErrorMsg fieldName={name} error={errorMessage}/>}
        </>
    );
}

export default TextBox;
